const {getStorage} = require("../util/Storage");
const {
	FLAGS,
	getList,
	setFlagAndSave: setFlagAndSaveShared,
	resetAllSaved: resetAllSavedShared,
	setDevelopmentEnv: setDevelopmentEnvShared,
	setProductionEnv,
	FLAG_OPTIONS_SCHEMA,
	FLAG_OPTIONS,
} = require("../../../shared/GlobalFlags");

const setFlagAndSave = function(name, value) {
	const storage = getStorage();
	return setFlagAndSaveShared(storage, name, value);
};

const resetAllSaved = function() {
	const storage = getStorage();
	return resetAllSavedShared(storage);
};

const setDevelopmentEnv = function() {
	const storage = getStorage();
	return setDevelopmentEnvShared(storage);
};

module.exports = {
	FLAGS,
	getList,
	setFlagAndSave,
	resetAllSaved,
	setDevelopmentEnv,
	setProductionEnv,
	FLAG_OPTIONS_SCHEMA,
	FLAG_OPTIONS,
};
